import styled from 'styled-components'
import { em } from 'polished'
import YouTube from 'react-youtube'

import { Text } from 'shared/Typography'

export const Container = styled.div`
  cursor: pointer;
  flex-shrink: 0;

  ${p => p.theme.mq.upMd} {
    max-width: 100%;
  }

  ${p => p.theme.mq.upLg} {

    &:hover {
      color: var(--color-D50);
    }
  }
`

export const ImageContainer = styled.div`
  position: relative;
`

export const Time = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${em(20, 12)};
  padding: 0 ${em(5, 12)};
  color: var(--color-W100);
  background-color: var(--color-D50);
  border-radius: 5px;
  font-size: 12px;
  line-height: 12px;
`

export const Image = styled.img`
  display: block;
  margin-bottom: ${em(15)};
  border-radius: 10px;
  width: 100%;

  ${p => p.theme.mq.upLg} {
    margin-bottom: ${em(8)};
  }
`

export const Title = styled(Text)`
  margin-bottom: ${em(10, 18)};
`

export const YouTubeStyled = styled(YouTube)`
  display: flex;
  width: 90vw;

  ${p => p.theme.mq.upLg} {
    width: ${em(760)};
    height: ${em(520)};
  }

  iframe {
    display: flex;
  }
`

export const YouTubeCrutch = styled(YouTube)`
  display: none;
`
